import { render, staticRenderFns } from "./Masque.vue?vue&type=template&id=656bf144&scoped=true&"
import script from "./Masque.vue?vue&type=script&lang=js&"
export * from "./Masque.vue?vue&type=script&lang=js&"
import style0 from "./Masque.vue?vue&type=style&index=0&id=656bf144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656bf144",
  null
  
)

export default component.exports